import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatoriService } from '../operatori.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs';
import { CerereType, Config, Locatie, LocatieRow, StateRow } from '../operatori.interface';

@Component({
    selector: 'app-edit-operator',
    templateUrl: './edit-operator.component.html',
    styleUrls: ['./edit-operator.component.scss'],
})
export class EditOperatorComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    successIcon: string = environment.config.customNotifications.icons.success;

    serviciiIds: number[] = [];
    cerereTypeIds: number[] = [];
    locatiiIds: number[] = [];

    configData: Config[] = [];
    stateRows: StateRow[] = [];
    locatiiData: Locatie[] = [];
    locatiiRows: LocatieRow[] = [];

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditOperatorComponent>,
        private notificationService: NotificationService,
        private authService: AuthService,
        private operatorService: OperatoriService
    ) { }

    ngOnInit(): void {
        this.loadFunctiiOperator();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        console.log('not implemented yet');
    }

    updateCheckedList(item: any, isHeaderCheckbox: boolean = false) {
        let arrayToUpdate = isHeaderCheckbox ? this.serviciiIds : this.cerereTypeIds;

        if (item.checked) {
            if (!arrayToUpdate.includes(item.id)) {
                arrayToUpdate.push(item.id);
            }
        } else {
            const index = arrayToUpdate.indexOf(item.id);
            if (index > -1) {
                arrayToUpdate.splice(index, 1);
            }
        }

        this.configData.forEach((group: Config) => {
            if (group.cereri_types.length > 0) {
                let totalItems = group.cereri_types.length;
                let selectedCount = group.cereri_types.filter((cerere) => this.cerereTypeIds.includes(cerere.id)).length;
                group.label = `${group.label.split('(')[0].trim()} (Selectate: ${selectedCount} / Total: ${totalItems})`;

                const correspondingRow = this.stateRows.find((row) => row.id === group.id);
                if (correspondingRow) {
                    correspondingRow.label = group.label;
                }
            }
        });

        if (isHeaderCheckbox) {
            // If it's a header checkbox, select/deselect all subitems without expanding/collapsing the panel
            item.cereri_types.forEach((cerere: any) => {
                cerere.checked = item.checked;
                this.updateCheckedList(cerere);
            });
            return;
        }
    }

    updateLocatiiList(item: LocatieRow) {
        if (item.checked) {
            if (!this.locatiiIds.includes(item.id)) {
                this.locatiiIds.push(item.id);
            }
        } else {
            const index = this.locatiiIds.indexOf(item.id);
            if (index > -1) {
                this.locatiiIds.splice(index, 1);
            }
        }
    }

    loadFunctiiOperator() {
        this.isLoading = true;
        this.operatorService
            .permisiuniList(this.data.id_user)
            .pipe(
                finalize(() => { this.isLoading = false; })
            ).subscribe((results) => {
                this.configData = results.data.config;
                this.serviciiIds = results.data.operator_allocated.servicii;
                this.cerereTypeIds = results.data.operator_allocated.cereri_types;
                this.locatiiData = results.data.locatii;
                this.locatiiIds = results.data.operator_allocated.locatii;

                this.configData.forEach((group: Config) => {
                    if (group.cereri_types.length > 0) {
                        let totalItems = group.cereri_types.length;
                        let selectedCount = group.cereri_types.filter((cerere: any) => this.cerereTypeIds.includes(cerere.id)).length;
                        group.label += ` (Selectate: ${selectedCount} / Total: ${totalItems})`;
                    }
                });

                this.locatiiRows = this.locatiiData.map((item: Locatie) => ({
                    id: item.id_locatie,
                    name: item.name,
                    address: item.address,
                    checked: this.locatiiIds.includes(item.id_locatie),
                }))

                this.stateRows = this.configData.map((item: Config) => ({
                    ...item,
                    // name: item.label,
                    checked: this.serviciiIds.includes(item.id),
                    cereri_types: item.cereri_types.map((cerere: CerereType) => ({
                        ...cerere,
                        name: cerere.label,
                        checked: this.cerereTypeIds.includes(cerere.id),
                    })),
                }));
            });
    }

    updateUtilizatori() {
        this.isLoading = true;
        this.operatorService
            .updateOperator(this.data.id_user, {
                cerereTypeIds: this.cerereTypeIds,
                serviciiIds: this.serviciiIds,
                locatiiIds: this.locatiiIds,
            })
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.success,
                        'Actualizare cu succes',
                        this.successIcon
                    );
                    this.closeDialog();
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
